import React from 'react';
import { Record } from '@fulcrumapp/fulcrum-core';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import { Tooltip, IconButton } from '@mui/material';
import { numberOfPoints, calculateArea, calculatePerimeterOrLength } from '../../sketch-editor/geo-tools';

interface Props {
  feature: Record;
}

const containerStyle = {
  width: '100%',
  opacity: 1,
  transform: 'scaleY(1)',
  transformOrigin: 'top',
  transition: 'transform 0.3s ease, opacity 0.3s ease',
  position: 'relative',
  padding: 0,
  clear: 'both',
  fontSize: 13,
  borderTop: '1px solid #c9c9c9',
  backgroundColor: '#e1e1e1',
} as React.CSSProperties;

const content = {
  display: 'flex',
  flexDirection: 'row',

  '@phone': {
    display: 'block',
  },
} as React.CSSProperties;

const editableContentStyle = {
  display: 'block',
  width: '58%',
  paddingRight: 12,
  marginTop: 10,
  marginBottom: 10,
  paddingLeft: 4,
  borderRadius: '3px',
  resize: 'none',
  backgroundColor: '#e1e1e1',
  overflow: 'auto',
} as React.CSSProperties;

const metaDataLabel = {
  width: '42%',
  paddingLeft: 12,
  paddingTop: 10,
  paddingBottom: 10,

  '@phone': {
    display: 'block',
    width: '100%',
    fontWeight: 'bold',
    paddingTop: 6,
  },
} as React.CSSProperties;

const iconStyle = {
  position: 'absolute',
  top: '20px',
  left: '72px',
  transform: 'translateY(-50%)',
  cursor: 'pointer',
} as React.CSSProperties;

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(
    () => {
      console.log('Text copied to clipboard');
    },
    (err) => {
      console.error('Failed to copy text: ', err);
    },
  );
};

const GeometryField = ({ feature }: Props) => {
  const label = 'Geometry';
  const { geometry } = feature;
  const geometryString = JSON.stringify(geometry);

  return (
    <div style={containerStyle}>
      <div style={content}>
        <div style={metaDataLabel}>
          <strong>{label}</strong>
          <Tooltip title="Copy GeoJSON Values" placement="top">
            <IconButton
              style={iconStyle}
              onClick={() => copyToClipboard(geometryString)}
            >
              <ContentCopyTwoToneIcon
                fontSize="small"
              />
            </IconButton>
          </Tooltip>
        </div>
        <div style={editableContentStyle}>
          <div>{numberOfPoints(geometry)}</div>
          <div>{calculatePerimeterOrLength(geometry)}</div>
          <div>{calculateArea(geometry)}</div>
        </div>
      </div>
    </div>
  );
};

export default GeometryField;
